import apiClient from './apiClient';

export interface QueryParams {
  report_type: 1 | 2;     // 1=廠商別, 2=廠商工繳別
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  process_from?: string;
  process_to?: string;
  dept_from?: string;
  dept_to?: string;
}

// Report 1: vendor-grouped stats
export interface StatRow {
  FD130_12: string;      // vendor code
  vendor_name: string;
  FD130_19: string;      // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

// Report 2: vendor+process-grouped stats
export interface StatRowByProcess {
  FD130_12: string;      // vendor code
  vendor_name: string;
  FD130_15: string;      // process code
  FD130_19: string;      // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface VendorSummary {
  FD130_12: string;
  vendor_name: string;
  FD130_19: string;
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface UnitSummary {
  FD130_19: string;   // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface QueryResponseType1 {
  report_type: 1;
  data: StatRow[];
  count: number;
  unit_summary: UnitSummary[];
  message?: string;
}

export interface QueryResponseType2 {
  report_type: 2;
  data: StatRowByProcess[];
  count: number;
  vendor_summary: VendorSummary[];
  unit_summary: UnitSummary[];
  message?: string;
}

export type QueryResponse = QueryResponseType1 | QueryResponseType2;

export const d306Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d306/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d306/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
